const OldTemplateBanner = () => {
	return (
		<div className="p-2 font-bold text-center bg-yellow-300 text-black z-50 w-full">
            This template is not the latest version. Please contact your manager to update the template before proceeding.
        </div>
	);
};

export default OldTemplateBanner;
